"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalInputFactoryCustomer = void 0;
class ExternalInputFactoryCustomer {
    static create(methodName, controlColl, currentInstance) {
        return undefined;
    }
}
exports.ExternalInputFactoryCustomer = ExternalInputFactoryCustomer;
